import { CrossIcon } from "@t8891/icon";
import { initCondition } from "../../pages/buyCarMenu/list";
import React from "react";

function calculate(value) {
  let val = value;

  if (value.includes("萬")) {
    const priceSplit = value.split("-");
    if (priceSplit[0] === "0") {
      val = value.split("-")[1] + "以下";
    }
    if (priceSplit[1] === "999999萬") {
      val = value.split("-")[0] + "萬以上";
    }
  }
  return val;
}

const LabelItem: React.FC<any> = ({ name }) => {
  return (
    <div
      className='w-90 bg-[#F0F6FF] text-14 px-18 whitespace-pre'
      style={{ textAlignLast: "justify", lineHeight: "46px" }}
    >
      {name}
    </div>
  );
};

const ConditionItem: React.FC<any> = ({ value, onClose }) => {
  return (
    <div
      className='rounded-4 h-24 flex items-center justify-center gap-6 pl-6 select-none'
      style={{ border: "1px solid #E8E8E8" }}
    >
      {calculate(value)}
      <div
        className='rounded-4 w-24 h-24 flex items-center justify-center gap-6 -mr-1'
        style={{ border: "1px solid #E8E8E8" }}
      >
        <CrossIcon fill='#3264FF' size={32} className='cursor-pointer' onClick={onClose} strokeWidth={4} />
      </div>
    </div>
  );
};

function reSetName({ data, item }) {
  let name = "";
  if (item.field === "brandId") {
    data.allBrand.map((v) => {
      v.items.map((vv) => {
        if (`${vv.value}` === item.value) {
          name = vv.enName || vv.name;
        }
      });
    });
  }
  if (item.field === "kindId") {
    data.kind.map((vv) => {
      if (`${vv.value}` === item.value) {
        name = vv.enName || vv.name;
      }
    });
  }

  if (item.field === "regionId") {
    data.region.map((v) => {
      v.regions.map((vv) => {
        if (`${vv.value}` === item.value) {
          name = vv.name;
        }
      });
    });
  }

  if (["price", "paymentType", "color", "insurance", "autoType"].includes(item.field)) {
    data[item.field].map((vv) => {
      if (`${vv.value}` === item.value) {
        name = vv.name;
      }
    });
    if (item.field === "price") {
      name = !!name ? name : `${item.value}萬`;
    }
  }

  return name;
}

const PressCondition: React.FC<any> = ({ data, params, setParams, refetch }) => {
  const { orders } = params;

  return (
    <div id='PressCondition' className='rounded-tr-4 rounded-tl-4 relative z-1 bg-white overflow-hidden'>
      <div className='flex gap-14'>
        <LabelItem name='您已選擇' />
        <div className='flex gap-x-20 gap-y-8 items-center w-800 flex-wrap py-10'>
          {orders?.length > 0 &&
            orders
              ?.filter((item) => !(item.field === "page" || item.field === "limit"))
              .map((item: any, index: number) => (
                <ConditionItem
                  key={item.name}
                  value={item.enName || item.name || reSetName({ item, data })}
                  onClose={() => {
                    let filterOrders = orders.filter((i) => i.field !== item.field);
                    let query = {};
                    if (item.field === "brandId") {
                      query = {
                        kindId: "",
                        kindIdName: "",
                      };
                      filterOrders = filterOrders.filter((item) => item.field !== "kindId");
                    }
                    setParams({
                      [item.field]: "",
                      [item.field + "Name"]: "",
                      orders: filterOrders,
                      ...query,
                    });
                  }}
                />
              ))}

          <div
            className='rounded-4 h-24 flex items-center justify-center gap-6 px-6 cursor-pointer bg-[#F7F7F7]'
            style={{ border: "1px solid #E8E8E8" }}
            onClick={() => {
              setParams({ ...initCondition, sort: "postDate-desc" });
              setTimeout(() => {
                refetch();
              });
            }}
          >
            清除條件
          </div>
        </div>
      </div>
    </div>
  );
};
export default PressCondition;
